import { isEmpty } from "lodash";
import { get } from "lodash-es";
import { reportsFormModel } from "./formModel";
import { trackingFormModel } from "./formModel";
const { formFields } = reportsFormModel;

export const quickAccessTrackingInitialValues = {
  trackingNumbers: "",
};

export const getInitialValues = (trackingNumbers = []) => {
  if (!isEmpty(trackingNumbers) && trackingNumbers.length > 1) {
    return {
      ...trackingNumbers
        .map((trackingNumber) => {
          if (
            trackingNumber.value &&
            !isEmpty(get(trackingNumbers, "[0].value", ""))
          ) {
            return {
              [trackingNumber.name]: trackingNumber.value,
            };
          }

          return {
            [trackingNumber.name]: "",
          };
        })
        .reduce((acc, curr) => ({ ...acc, ...curr })),
    };
  }

  if (!isEmpty(get(trackingNumbers, "[0].value", ""))) {
    return {
      trackingNumbers: get(trackingNumbers, "[0].value", ""),
    };
  }

  return {
    trackingNumbers: "",
  };
};

export const initialValues = {
  [trackingFormModel.formFields.trackingNumbers.name]: [
    {
      name: "tracking-0",
      value: "",
    },
  ],
};

export const reportsFormInitialValues = {
  [formFields.fromDay.name]: "",
  [formFields.fromMonth.name]: "",
  [formFields.fromYear.name]: "",
  [formFields.toDay.name]: "",
  [formFields.toMonth.name]: "",
  [formFields.toYear.name]: "",
  [formFields.sortReportOption.name]: "",
  [formFields.typeReportOption.name]: "",
};

export const getPodInitialValues = (trackingNumbers) => {
  return {
    ...trackingNumbers
      .map((trackingNumber) => {
        if (trackingNumber.value) {
          return {
            [trackingNumber.name]: trackingNumber.value,
          };
        }

        return {
          [trackingNumber.name]: "",
        };
      })
      .reduce((acc, curr) => ({ ...acc, ...curr }), []),
  };
};
